import { CreativeTextPage } from './CreativeTextPage';

export default CreativeTextPage;
